module.exports = __webpack_public_path__ + "img/wand-icon.0083ac35.svg";